import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatTree, MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ContextMenuComponent } from '../context-menu/context-menu.component';
import { CdkMenuModule } from '@angular/cdk/menu';
import { SchemaTreeResult } from '../../interfaces/SchemaTreeResult';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SchemaTree } from '../../clases/SchemaTree';
import { BeNeo4jService } from '../../services/be-neo4j.service';
import { TreeDynamicDataSource } from '../../clases/TreeDynamicDataSource';
import { Subject } from 'rxjs';


@Component({
  selector: 'schema-tree',
  standalone: true,
  imports: [
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    ContextMenuComponent,
    CdkMenuModule,
    MatProgressBarModule
  ],
  templateUrl: './schema-tree.component.html',
  styleUrl: './schema-tree.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchemaTreeComponent implements AfterViewInit{

  @Input() initData!: SchemaTree[];
  @Output() result: EventEmitter<SchemaTreeResult> = new EventEmitter();
  @ViewChild("tree", {static: false}) treeControl!: MatTree<SchemaTree>;

  selectedItem: SchemaTree | null = null;

  newData: Subject<SchemaTree[]> = new Subject<SchemaTree[]>();

  dataSource: TreeDynamicDataSource | SchemaTree[]= [];

  constructor(private beNeo4jService: BeNeo4jService){}

  ngAfterViewInit(): void {
    this.dataSource = new TreeDynamicDataSource(this.treeControl, this.beNeo4jService);
    this.dataSource.data = this.initData;
  }

  childrenAccessor = (node: SchemaTree) => node.children || [];

  hasChild = (_: number, node: SchemaTree) => node.has_children;

  onitemSelected(schema: SchemaTree){
    this.selectedItem = schema;
  }

  sendResult(result: SchemaTreeResult){
    this.result.emit(result);
  }

  setSchemaTree(schemaTree: SchemaTree[]){
    (this.dataSource as TreeDynamicDataSource).data = schemaTree;
  }
}